import * as React from 'react';
import ColorPickerSettings from '../components/ColorPickerSettings';
import DashBoardLogoSettings from '../components/DashBoardLogoSettings/DashBoardLogoSettings';
import EditorTextSettings from '../components/EditorTextSettings';
import EditorLogoSettings from '../components/EditorLogoSettings';
import { BrandColorSettings, SettingsSaveButton } from '@moovly/moovly-settings';
const SettingsContainer = () => {
  return (
    <div className="container-fluid">
      <div className="row g-4">
        <div className="col-6">
          <EditorLogoSettings />
        </div>
        <div className="col-6">
          <DashBoardLogoSettings />
        </div>
        <div className="col-6">
          <EditorTextSettings />
        </div>
        <div className="col-6">
          <ColorPickerSettings />
        </div>
        <div className="col-12">
          <BrandColorSettings />
        </div>
      </div>
      <div className="d-flex mt-3 justify-content-end">
        <SettingsSaveButton />
      </div>
    </div>
  );
};

export default SettingsContainer;
